/* global G */
/* eslint-disable */
import { curry } from 'lib/util'
import session from 'app/_shared/session'

/**
 * Callback for removing the item from the state of the list.
 *
 * @callback removeItem
 * @param {Object[]} prevState
 * @param {Object} fetchedTicket
 */
/** @type {removeItem} */
export const removeItem = (prevState, removedItem) => {
  const newState = [...prevState]
  const existingTicket = prevState.find(ticket => ticket.key === removedItem.key)

  if (existingTicket) {
    newState.splice(newState.indexOf(existingTicket), 1);
  }

  return newState
}

/**
 * Callback for adding the item to the state of the list.
 *
 * @callback addItem
 * @param {Object[]} prevState
 * @param {Object} fetchedTicket
 */

/** @type {addItem} */
export const addItem = (prevState, fetchedItem) => {
  const newState = removeItem(prevState, fetchedItem)

  newState.unshift(fetchedItem)

  return newState
};

/**
 * Get the new item and return it alongside
 * a callback handling the state change.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param event                         event containing the new ticket id
 * @returns {Promise<*>}
 */
// eslint-disable-next-line no-unused-vars
const updateList = async (module, component, event) => {
  const obj = module[G.MODEL]
  const { ticket } = module[G.MODEL][G.CHILDREN]
  const { api, version } = ticket[G.PROPS]
  const ticketId = event.id
  const url = `/api/v${version}/${api}/${ticketId}`

  try {
    const fetchedTicket = await obj[G.ADAPTER][G.HTTP].get({ url })

    return fetchedTicket.refs.assignee?.[0]?.key === session(module).user.key()
        ? { item: fetchedTicket, addItem }
        : { item: fetchedTicket, addItem: removeItem };

  } catch (e) {
    console.error(e)
  }
  return {}
}
export default curry(updateList)
